import React from "react";
import { Text, View, TouchableOpacity, Linking, Platform, SafeAreaView, Dimensions, ScrollView } from "react-native";
import { useTheme } from './ThemeContext';
import packageJson from '../../package.json';

const { width: screenWidth, height: screenHeight } = Dimensions.get("window");
const isSmallScreen = screenWidth < 375; // iPhone SE, iPhone 13 mini
const isLargeScreen = screenWidth >= 390; // iPhone 14 Plus, iPhone 15 Plus, etc.
const scaleFactor = isSmallScreen ? 0.85 : (isLargeScreen ? 1.0 : 0.95);

export default function About() {
  const { themeValues } = useTheme();

  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: themeValues.background,
      }}
    >
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: themeValues.background,
        }}
        contentContainerStyle={{
          flexGrow: 1,
          justifyContent: "center",
          alignItems: "center",
          padding: 20 * scaleFactor,
          paddingTop: Platform.OS === 'ios' ? (isLargeScreen ? 120 : 100) : 60,
        }}
      >
      <View
        style={{
          transform: [{ scale: scaleFactor }]
        }}
      >
      <Text
        style={{
          color: themeValues.primary,
          fontSize: (Platform.OS === 'web' ? 48 : 24) * scaleFactor,
          fontWeight: "bold",
          textAlign: "center",
          marginBottom: 20,
        }}
      >
        About MeditRate
        <Text
          style={{
            fontSize: (Platform.OS === 'web' ? 32 : 16) * scaleFactor,
            fontWeight: "normal",
          }}
        >
          {" "}v{packageJson.version}
        </Text>
      </Text>

      <Text
        style={{
          color: themeValues.text,
          fontSize: (Platform.OS === 'web' ? 28 : 16) * scaleFactor,
          textAlign: "center",
          lineHeight: (Platform.OS === 'web' ? 36 : 24) * scaleFactor,
        }}
      >
        Did you know that human hearts naturally synchronize with rhythmic sounds we hear? This phenomenon is called <Text style={{ fontWeight: "bold", color: themeValues.text }}>entrainment</Text> - when your heartbeat gradually matches the pace of external rhythms.
        {"\n\n"}
        <Text style={{ fontWeight: "bold", color: themeValues.text }}>MeditRate</Text> harnesses this natural biological response to help you achieve deeper relaxation. By listening to steady heartbeat-like sounds at your desired pace, your heart rate naturally aligns with the rhythm, promoting a calm meditative state.
        {"\n\n"}
        Whether you're looking to slow your heart rate for stress relief or maintain a steady rhythm for focus, <Text style={{ fontWeight: "bold", color: themeValues.text }}>MeditRate</Text> provides the tools to guide your body into your ideal state of relaxation.
        {"\n\n"}
        Simply set your target beats per minute, choose your meditation duration, and let your heart find its natural rhythm.
      </Text>

      <TouchableOpacity
        style={{ marginTop: 20 }}
        onPress={() => Linking.openURL('https://www.meditrate.com')}
      >
        <Text
          style={{
            color: themeValues.primary,
            fontSize: Platform.OS === 'web' ? 28 : 16,
            textAlign: "center",
            textDecorationLine: "underline",
          }}
        >
          www.meditrate.com
        </Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={{ marginTop: 20 }}
        onPress={() => Linking.openURL('https://apps.apple.com/us/app/meditrate/id6759229009')}
      >
        <Text
          style={{
            color: themeValues.primary,
            fontSize: Platform.OS === 'web' ? 28 : 16,
            textAlign: "center",
            textDecorationLine: "underline",
          }}
        >
          Download on App Store
        </Text>
      </TouchableOpacity>

      <View style={{ marginTop: 30 }}>
        <Text
          style={{
            color: themeValues.muted,
            fontSize: 12,
            textAlign: "center",
          }}
        >
          © {new Date().getFullYear()} MeditRate. All rights reserved.
        </Text>
      </View>
      </View>
      </ScrollView>
    </SafeAreaView>
  );
}
